<template>
  <div ref="chartScatter" style="width: 100%; height: 100%"></div>
</template>

<script>
  import echarts from "./echarts";
  import resize from "@/utils/echartsResize";
  export default {
    name: "ChartScatter",
    mixins: [resize],
    props: {
      yName: String,
      chartData: {
        type: Array,
        default: () => ({}),
      },
    },
    data() {
      this.chart = null;
      return {};
    },
    created() {},
    mounted() {
      this.init();
      this.$watch("chartData", (chartData) => {
        this.chart &&
          this.chart.setOption({
            yAxis: { name: this.yName },
            series: [
              {
                name: "scatter",
                data: chartData,
              },
            ],
          });
      });
    },
    beforeDestroy() {
      // 销毁echarts实例
      this.chart && this.chart.dispose();
      this.chart = null;
    },
    methods: {
      init() {
        this.chart = echarts.init(this.$refs.chartScatter);
        const option = {
          grid: {
            // containLabel: true,
            top: "8%",
            right: "6.5%",
            bottom: "7%",
            left: "7%",
            show: true,
            backgroundColor: "rgba(0,255,246,0.02)",
            borderWidth: 0,
          },
          xAxis: [
            {
              position: "bottom",
              axisLine: {
                lineStyle: { color: "rgba(35,156,249,0.4)" },
              },
              splitLine: {
                lineStyle: { color: "rgba(35,156,249,0.4)" },
              },
              axisTick: { show: false },
              axisLabel: {
                margin: 20,
                fontSize: 18,
                color: "rgba(255,255,255,0.7)",
              },
              name: "火点报\n警次数",
              nameTextStyle: {
                color: "#239CF9",
                fontSize: 16,
                fontWeight: 500,
              },
            },
            {
              position: "top",
              axisLine: {
                lineStyle: { color: "rgba(35,156,249,0.4)" },
              },
              axisTick: { show: false },
            },
          ],
          yAxis: {
            // offset: 4,
            // max: function (value) {
            //   return value.max + 2;
            // },
            boundaryGap: ['0%', '1%'],
            name: this.yName,
            nameTextStyle: {
              color: "#239CF9",
              fontSize: 16,
              fontWeight: 500,
            },
            splitLine: { show: false },
            axisLine: { show: false },
            axisLabel: {
              margin: 30,
              fontSize: 18,
              color: "rgba(255,255,255,0.7)",
            },
            axisTick: {
              length: 24,
              lineStyle: {
                color: "rgba(255,255,255,0.5)",
              },
            },
            minorTick: {
              show: true,
              length: 18,
              lineStyle: {
                color: "rgba(255,255,255,0.3)",
              },
            },
          },
          // dataset: [
          //   {
          //     source: this.chartData,
          //   },
          //   {
          //     transform: {
          //       type: "ecStat:regression",
          //       // 'linear' by default.
          //       // config: { method: 'linear', formulaOn: 'end'}
          //     },
          //   },
          // ],
          series: [
            {
              name: "scatter",
              type: "scatter",
              symbolSize: 36,
              // 大数据量优化
              large: true,
              itemStyle: {
                color: "#26C9F6",
              },
              data: this.chartData,
            },
            // {
            //   name: "line",
            //   type: "line",
            //   datasetIndex: 1,
            //   symbolSize: 0.1,
            //   symbol: "circle",
            //   label: { show: true, fontSize: 16 },
            //   labelLayout: { dx: -20 },
            //   encode: { label: 2, tooltip: 1 },
            // },
          ],
        };
        this.chart && this.chart.setOption(option);
      },
    },
  };
</script>

<style scoped lang="less"></style>
